import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getIndicatorResultFormConfig = () => {
  return {
    TargetValueTxt: {
      fieldId: 'TargetValueTxt',
      formLabel: t(`indicator_results.fields.text_result`),
      columnHeader: t(`indicator_results.columns.result`),
    },
    TargetValueNum: {
      fieldId: 'TargetValueNum',
      formLabel: t(`indicator_results.fields.num_result`),
      columnHeader: t(`indicator_results.columns.result`),
      displayType: { displayType: 'number' },
    },
    ResultDate: {
      fieldId: 'ResultDate',
      formLabel: t(`indicator_results.fields.date`),
      columnHeader: t(`indicator_results.columns.date`),
      displayType: { displayType: 'date' },
    },
    Description: {
      fieldId: 'Description',
      formLabel: t(`indicator_results.fields.description`),
    },
    files: {
      fieldId: 'files',
      formLabel: t(`fields.newFiles`),
    },
  } as const satisfies FormConfig;
};
